import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";

const allowedLanguages = ["en", "ar"];
let lng = window.lang == null ? 'en':window.lang;

const storageLanguage = localStorage.getItem("language");
if (storageLanguage && allowedLanguages.indexOf(storageLanguage) > -1) {
  lng = window.lang;
}


i18n
.use(XHR)
.use(initReactI18next)
.init({
  lng,
  debug: false,
  keySeparator: false,
  interpolation: {
    escapeValue: false
  },
  fallbackLng: 'en',
  backend: {
    loadPath: '/.store.ftth.ui/react-app/build/translations/{{lng}}.json',
    //loadPath: '/translations/{{lng}}.json',
    allowMultiLoading: true
  },
  react: {
    wait: true,
    useSuspense: true
  }
});


export default i18n;
